import axios from "axios";

import { PlayerStats } from "@/lib/types";

const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL_SPO;

const getPlayerStats = async (token: string) => {
  const response = await axios.get(`${VITE_API_BASE_URL}/magnus/stats/player`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return response.data.data ? (response.data.data as PlayerStats[]) : [];
};

export { getPlayerStats };
